import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { StreamService } from '../../services/stream.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-assessment-description',
  templateUrl: './assessment-description.component.html',
  styleUrl: './assessment-description.component.scss'
})
export class AssessmentDescriptionComponent implements OnInit, OnDestroy {
	@ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
	@Output() nextButton = new EventEmitter<boolean>();
	
	@Input() description: any;
	sanitizedContent: any;
	
	private videoStream!: MediaStream;
	passConditionsObserve!: Observable<boolean>;
	passConditionObservable!: Subscription;

	constructor(private sanitizer: DomSanitizer, private streamService: StreamService) { }

	async ngOnInit() {
		this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(this.description);

		
		this.passConditionsObserve = this.streamService.passConditions$;

		this.passConditionObservable = this.passConditionsObserve.subscribe(pass => {
      this.nextButton.emit(pass);
    });

		navigator.mediaDevices.getUserMedia({ 
			video: this.streamService.selectedCamera ? { deviceId: this.streamService.selectedCamera } : true,
			audio: this.streamService.selectedMicrophone ? { deviceId: this.streamService.selectedMicrophone } : true
		}).then(async (stream) => {
			this.videoStream = stream;
			await this.setVideoElement();
			this.streamService.checkConditions(this.videoPlayer.nativeElement);
		})
		.catch(error => console.error('Error accessing camera:', error));
	}

	ngOnDestroy(): void {
		if (this.videoStream) {
      this.videoStream.getTracks().forEach(track => track.stop());
    }
    
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      this.videoPlayer.nativeElement.srcObject = null;
    }

		this.passConditionObservable.unsubscribe();
		this.streamService.stopStreaming();
	}

	async setVideoElement() {
		this.videoPlayer.nativeElement.srcObject = this.videoStream;
		this.videoPlayer.nativeElement.play();
  }
}
